import { render, staticRenderFns } from "./TestimonialShowPage.vue?vue&type=template&id=1d2064e6&"
import script from "./TestimonialShowPage.vue?vue&type=script&lang=js&"
export * from "./TestimonialShowPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports